/**
 * Internal
 */
import { createReducer } from 'state/utils';
import * as actions from 'state/action-types';

export default createReducer(null, {
	[actions.SET_IN_PROGRESS_OPERATION]: (state, action) => action.payload.operation,
});
